<template>
  <div class="wrapper">
    <div class="back">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/exam/exam-management' }">返回</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        <el-breadcrumb-item>成绩统计</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="score">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="成绩统计" name="first">
          <div class="stulist">
            <el-table size="mini" :data="stulist" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe>
              <el-table-column align="center" width="50" label="序号">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column label="姓名" prop="stuInfo.studentUserInfo.realname"></el-table-column>

              <el-table-column label="平台账号" prop="stuInfo.name" width="150"></el-table-column>

              <el-table-column label="开考时间" prop="start_time" width="200"></el-table-column>

              <el-table-column label="答题时长">
                <template slot-scope="scope">
                  <span>{{ getHMS(scope.row.last_time) }}</span>
                </template>
              </el-table-column>

              <el-table-column label="成绩" prop="total_score" align="center"></el-table-column>

              <el-table-column label="正确" prop="right_num" align="center"></el-table-column>

              <el-table-column label="错误" prop="wrong_num" align="center"></el-table-column>

              <el-table-column label="作答次数" prop="submit_times" align="center"></el-table-column>

              <el-table-column label="状态" prop="submit_times" align="center">
                <template slot-scope="scope">
                  <span style="color: green" v-if="scope.row.last_time > 0">已交卷</span>
                  <span v-else>未交卷</span>
                </template>
              </el-table-column>

              <el-table-column label="及格" prop="total_score" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.total_score">
                    <span style="color: green" v-if="scope.row.total_score >= passscore">及格</span>
                    <span style="color: red" v-else>不及格</span>
                  </span>
                  <span v-else>--</span>
                </template>
              </el-table-column>

              <el-table-column width="200" label="阅卷时间" prop="tch_check_date" align="center">
              </el-table-column>

              <el-table-column label="阅卷评语" prop="tch_comment" align="center">
              </el-table-column>

              <el-table-column align="center" label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                  <el-link v-if="!scope.row.tch_check_date" class="quest_btn" type="primary" @click="CorrectExam(scope.row)">阅卷评分</el-link>
                  <el-link v-else class="quest_btn" type="primary" @click="CorrectExam(scope.row)">查看成绩</el-link>

                  <el-link class="quest_btn" type="primary" @click="deleteStuExam(scope.row)">删除</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="排行榜" name="second">
          <div class="ranklist">
            <el-table size="mini" :data="ranklist" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe>
              <el-table-column align="center" width="50" label="序号">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column label="姓名" prop="name"></el-table-column>

              <el-table-column label="开考时间" prop="start_time" width="200"></el-table-column>

              <el-table-column label="答题时长">
                <template slot-scope="scope">
                  <span>{{ getHMS(scope.row.last_time) }}</span>
                </template>
              </el-table-column>

              <el-table-column label="成绩" prop="total_score" align="center"></el-table-column>

              <el-table-column label="及格" prop="total_score" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.total_score">
                    <span style="color: green" v-if="scope.row.total_score >= passscore">及格</span>
                    <span style="color: red" v-else>不及格</span>
                  </span>
                  <span v-else>--</span>
                </template>
              </el-table-column>

              <el-table-column label="交卷次数" prop="submit_times" align="center"></el-table-column>

              <el-table-column label="状态" prop="submit_times" align="center">
                <template slot-scope="scope">
                  <span style="color: green" v-if="scope.row.last_time > 0">已交卷</span>
                  <span v-else>未交卷</span>
                </template>
              </el-table-column>

              <el-table-column width="200" label="阅卷时间" prop="tch_check_date" align="center">
              </el-table-column>

              <el-table-column label="阅卷评语" prop="tch_comment" align="center">
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  getExamStuList,
  getExamRanking,
  deleteStuExam,
} from "@/api/educational";

export default {
  name: "exam-result",
  data() {
    return {
      activeName: "first",
      title: "",
      passscore: 0,
      exma_id: "",
      stulist: [], //考生列表
      ranklist: [], //排行榜
      page_no: 1,
      page_size: 20,
      total: 0,
    };
  },
  mounted() {
    this.title = this.$route.query.title;
    this.exma_id = this.$route.query.id;
    this.passscore = this.$route.query.passscore;

    console.log(this.title);
    console.log(this.exma_id);
    this.getExamStuList();
  },

  methods: {
    handleClick() {
      console.log("切换页面");
      console.log(this.activeName);
      if (this.activeName == "first") {
        this.getExamStuList();
      } else if (this.activeName == "second") {
        this.getExamRanking();
      }
    },
    getExamStuList() {
      getExamStuList({
        examId: this.exma_id,
      }).then((res) => {
        console.log("考生列表");
        console.log(res);
        this.stulist = res.examStuList;
      });
    },
    getExamRanking() {
      getExamRanking({
        page_no: 1,
        page_size: 500,
        examId: this.exma_id,
      }).then((res) => {
        console.log("考生排行列表");
        console.log(res);
        this.ranklist = res.examStuList;
      });
    },

    CorrectExam(row) {
      console.log("阅卷信息");
      console.log(row);
      this.$router.push({
        name: "correct-exam",
        query: {
          exam_id: this.exma_id,
          stu_id: row.student_user_id,
          title: this.title,
          realname: row.stuInfo.studentUserInfo.realname,
          eduCampusId: row.stuInfo.educational_institution_campus_id,
        },
      });
    },

    deleteStuExam(row) {
      this.$confirm("确定删除该学生的考试记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteStuExam({
          examId: this.exma_id,
          stuId: row.stuInfo.id,
        }).then((res) => {
          console.log("删除学生考试记录");
          console.log(res);
          if (res.is_delete) {
            this.$message.success("删除成功");
            this.getExamStuList();
          }
        });
      });
    },

    getHMS(time) {
      const hour =
        parseInt(time / 3600) < 10
          ? "0" + parseInt(time / 3600)
          : parseInt(time / 3600);
      const min =
        parseInt((time % 3600) / 60) < 10
          ? "0" + parseInt((time % 3600) / 60)
          : parseInt((time % 3600) / 60);
      const sec =
        parseInt((time % 3600) % 60) < 10
          ? "0" + parseInt((time % 3600) % 60)
          : parseInt((time % 3600) % 60);
      return hour + ":" + min + ":" + sec;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin: 10px;
  padding-top: 5px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;

  background: white;
  border-radius: 5px;

  .back {
    margin-top: 15px;
  }

  .score {
    margin-top: 20px;
  }

  .stulist {
    .quest_btn {
      margin-left: 10px;
      margin-right: 10px;
    }
  }
}
</style>